import { t } from "@lingui/core/macro";
import { RegrelloButton } from "@regrello/ui-core";

export function ErrorContent({
  requestVerification,
  isLoading,
}: {
  requestVerification: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
}) {
  return (
    <form className="flex flex-col mt-10 gap-10" onSubmit={requestVerification}>
      <p className="text-base">{t`Unknown error occured, please try again.`}</p>
      <p className="text-base">{t`If the issue persists, please contact your Regrello Administrator.`}</p>

      <RegrelloButton className="w-full capitalize" intent="primary" loading={isLoading} type="submit">
        {t`Try again`}
      </RegrelloButton>
    </form>
  );
}
